export const meta = {
  id: 'A04',
  slug: 'meu-plano',
  title: 'Conheça seu Plano',
  description: 'Entenda como objetivos, competências, metas e ações organizam seu desenvolvimento.',
  profile: 'student',
  category: 'plano',
  type: 'screen',
  status: 'published',
  order: 90,
  keywords: ['plano', 'meu plano', 'objetivo', 'metas', 'ações', 'competências'],
  previous: 'A03',
  next: 'A05',
  related: ['A03', 'A05'],
  updatedAt: '2026-08-17',
  appVersion: 'v1'
}

# Conheça seu Plano

Seu Plano transforma desenvolvimento em direção prática. Ele organiza **onde você quer chegar e quais ações ajudam a avançar**.

## Como as partes se conectam

**Diagnóstico identifica → Plano organiza → Jornada ajuda a executar.**

Conforme a configuração disponível para você, o Plano pode reunir objetivo, competências prioritárias, metas, ações, relação com sua Jornada e acompanhamento de progresso.

<HelpImage alt="Plano de desenvolvimento do Aluno" pendingId="A04.1" />

## Como utilizar

<Steps>
  <Step title="Relembre seu objetivo">
    Use o objetivo como referência para avaliar se suas prioridades continuam fazendo sentido.
  </Step>
  <Step title="Observe competências e metas">
    Entenda o que precisa evoluir e quais resultados estão sendo buscados.
  </Step>
  <Step title="Execute as ações">
    Use Jornada, Formações, Treinamentos e outras experiências relacionadas quando estiverem disponíveis.
  </Step>
</Steps>

<Callout type="tip">
  Um Plano só produz desenvolvimento quando sai da intenção e vira ação acompanhada.
</Callout>
